export default __webpack_public_path__ + "img/afbef6ba358e862866098238188bcf72.png";